import { render, staticRenderFns } from "./chat-menu.svg.vue?vue&type=template&id=73d2b13a&"
import script from "./chat-menu.svg.vue?vue&type=script&lang=js&"
export * from "./chat-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports